var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 204,
    viewBox: "0 0 187 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187 47.5C187 133.933 116.933 204 30.5 204C-55.9326 204 -126 133.933 -126 47.5C-126 -38.9326 -55.9326 -109 30.5 -109C116.933 -109 187 -38.9326 187 47.5ZM-66.4346 47.5C-66.4346 101.035 -23.0355 144.435 30.5 144.435C84.0355 144.435 127.435 101.035 127.435 47.5C127.435 -6.0355 84.0355 -49.4346 30.5 -49.4346C-23.0355 -49.4346 -66.4346 -6.0355 -66.4346 47.5Z",
    fill: "#0B2E75",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTop);
export default __webpack_public_path__ + "static/media/left-top.b5566e1c09e57dc3a475164ed7aa711a.svg";
export { ForwardRef as ReactComponent };